import { render, staticRenderFns } from "./DashBoardView.vue?vue&type=template&id=ac71371e&scoped=true"
import script from "./DashBoardView.vue?vue&type=script&lang=js"
export * from "./DashBoardView.vue?vue&type=script&lang=js"
import style0 from "./DashBoardView.vue?vue&type=style&index=0&id=ac71371e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac71371e",
  null
  
)

export default component.exports